'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SKIP = exports.SKIP = 'skipInitialCall';
var EQUALS = exports.EQUALS = 'equals';
var OBSERVER = exports.OBSERVER = '__OBSERVER__';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-observers/lib/constants.js
// module id = 273
// module chunks = 0